import { Component, Input } from '@angular/core';

export interface PremiumDiscountElevatedPeriod {
  endDate?: string;
  tradingDays?: number;
  reason?: string;
  reasonTooltip?: string;
}

@Component({
  selector: 'ft-premium-discount-elevated',
  templateUrl: './premium-discount-elevated.component.html',
  styleUrls: ['./premium-discount-elevated.component.scss'],
})
export class PremiumDiscountElevatedComponent {
  @Input() elevatedPeriods: PremiumDiscountElevatedPeriod[];
}
